<template>
  <div class="content">
    <controlbar
      :dispItems="devices"
      @input-event="setDevices"
      @list-reload="reload"
    >
    </controlbar>
    <div class="center">
      <table class="content_title" rules="rows">
        <tr class="items_table">
          <th class="table_checkbox">
            <input
              type="checkbox"
              class="checkbox"
              :checked="checked"
              @click="allCheckedAction"
            />
          </th>
          <td class="table_contents">
            <label class="device_id_label">
              {{ deviceIdLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="device_name_label">
              {{ deviceNameLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="phone_number_label">
              {{ phoneNumberLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="create_date_time">
              {{ createDateTime }}
            </label>
          </td>
          <td class="table_contents">
            <label class="last_update_date_time_label">
              {{ lastUpdateDateTimeLabel }}
            </label>
          </td>
        </tr>
      </table>

      <div class="table_scroll" :style="{height: tableHeight}">
        <table class="items_table" rules="rows">
          <tr
            class="item_table_row"
            v-for="dispDevice in devices"
            :key="dispDevice.deviceID"
          >
            <th class="table_checkbox">
              <input
                type="checkbox"
                class="checkbox"
                v-model="dispDevice.checked"
                @click="checkedAction(dispDevice)"
              />
            </th>
            <td class="table_contents" @click="setActive(dispDevice)">
              <label class="device_id">
                {{ dispDevice.deviceId }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispDevice)">
              <label class="device_name">
                {{ dispDevice.deviceName }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispDevice)">
              <label class="phone_number">
                {{ dispDevice.phoneNumber2 }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispDevice)">
              <label class="create_date_time">
                {{ dispDevice.createDateTime }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispDevice)">
              <label class="last_update_date_time">
                {{ dispDevice.lastUpdateDateTime }}
              </label>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="bottom">
      <pagination
        v-model="page"
        :records="total"
        :per-page="pageSize"
        :options="{texts: {count: '{from} - {to}/{count}件'}, chunk: 5}"
        @paginate="setDevices(page - 1)"
      >
      </pagination>
    </div>
    <div class="false_modal_window" v-if="showFalseModal">
      <falseModalWindow :question="falseWord" @close="close">
      </falseModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import controlbar from './controlbar.vue'
import falseModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import Pagination from 'vue-pagination-2'

export default {
  data() {
    return {
      deviceIdLabel: '端末ID',
      deviceNameLabel: '端末名',
      phoneNumberLabel: '電話番号',
      createDateTime: '登録日時',
      lastUpdateDateTimeLabel: '最終アクセス',
      windowHeight: '',
      showFalseModal: false,
      falseWord: '',
      checked: false,
      showloadingModal: false,
      pageSize: 20,
      page: 1,
      prevTotal: 0,
      prevPageNo: 0,
      prevSearchWord: ''
    }
  },
  computed: {
    devices() {
      return this.$store.state.devices.devices
    },
    total() {
      if ((this.page - 1) * this.pageSize <= this.$store.state.devices.total) {
        return this.$store.state.devices.total
      }
      return this.prevTotal
    },
    isOverPage() {
      return (this.page - 1) * this.pageSize >= this.$store.state.devices.total
    },
    lastPage() {
      const last = Math.ceil(this.$store.state.devices.total / this.pageSize)
      return last === 0 ? 1 : last
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    tableHeight() {
      const otherHeight = 138
      return this.windowHeight - otherHeight + 'px'
    }
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    this.$store.dispatch('devices/clearSelectedDeviceList')
    this.$store.state.prevPageNo = 0
    this.$store.state.prevSearchWord = ''
    this.setDevices(0)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    controlbar,
    falseModalWindow,
    loadingModalWindow,
    Pagination
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    allCheckedAction(e) {
      // リストのチェックボックスを全てチェックする。
      this.checked = !this.checked
      for (let i = 0; i < this.devices.length; i++) {
        this.devices[i].checked = this.checked
      }
      this.$store.dispatch('devices/updateSelectedDeviceList', this.devices)
    },
    checkedAction(device) {
      device.checked = !device.checked
      this.$store.dispatch('devices/updateSelectedDeviceList', [device])
    },
    close(e) {
      this.showFalseModal = false
    },
    async reload() {
      this.$store.dispatch('devices/clearSelectedDeviceList')
      await this.setDevices(
        this.$store.state.prevPageNo,
        this.$store.state.prevSearchWord
      )
    },
    async setDevices(pageNo, searchWord = null) {
      this.showloadingModal = true
      let focus = document.activeElement
      focus.blur()
      try {
        searchWord =
          searchWord === null ? this.$store.state.prevSearchWord : searchWord
        await this.$store.dispatch('devices/setDevices', {
          pageNo: pageNo,
          searchWord: searchWord
        })
        if (pageNo > 0) {
          if (this.isOverPage) {
            this.page = this.lastPage
          } else {
            this.page = pageNo + 1
          }
        } else {
          this.page = 1
        }
        this.$store.state.prevPageNo = pageNo
        this.$store.state.prevSearchWord = searchWord
        this.checked = false
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_140001
        let eventType = 3
        let reason = 'MSGCRC0017'
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0017.name +
            this.errorMsg.MSGCRC0017.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    },
    async setActive(payload) {
      this.showloadingModal = true
      let tr = event.currentTarget.parentNode.parentNode.querySelectorAll('tr')
      for (let i = 0; i < tr.length; i++) {
        tr[i].className = 'item_table_row'
      }
      event.currentTarget.parentNode.className = 'item_table_row active'
      try {
        await this.$store.dispatch('devices/setDetailDevice', payload)
        if (location.pathname !== '/devices/detail') {
          this.$router.push('../devices/detail')
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_140002
        let eventType = 3
        let reason = 'MSGCRC0018'
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0018.name +
            this.errorMsg.MSGCRC0018.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>
<style scoped>
.table_contents:nth-child(2) {
  table-layout: fixed;
  width: 14%;
}
.table_contents:nth-child(3),
.table_contents:nth-child(4) {
  table-layout: fixed;
  width: 15%;
}
.table_contents:nth-child(5),
.table_contents:nth-child(6) {
  table-layout: fixed;
  width: 18%;
}
</style>



// WEBPACK FOOTER //
// src/components/devices/devicesList.vue